<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title Feiertage
    .sub-headline Hier können Sie alle Feiertage pflegen.

    .add-holiday.margin-top
      b-field(label="Feiertage automatisch hinzufügen", label-position="on-border")
        b-select(v-model="year")
          option(v-for="i in 10", :value="new Date().getFullYear() + i - 1") Feiertage von {{ new Date().getFullYear() + i - 1 }}
      .button-wrapper
        b-button(
          type="is-light",
          @click="downloadHolidays()",
          :disabled="!year"
        ) Hinzufügen
    div.margin-top oder einen Feiertag manuell hinzufügen
    .form
      b-field.margin-top(label="Datum", label-position="on-border")
        v-date-picker(v-model="singleVacationDay.date")
      b-field.margin-top(label="Name", label-position="on-border")
        b-input(v-model="singleVacationDay.name")
      b-field.margin-top(label="Beschreibung", label-position="on-border")
        b-input(v-model="singleVacationDay.description")
      b-button(
          type="is-light",
          @click="addSingleHoliday()",
          :disabled="!singleVacationDay.name || !singleVacationDay.description"
        ) Hinzufügen

    .holidays-wrapper.margin-top(v-if="holidays && holidays.length > 0")
      .card.margin-top
        .main
          b-table(
            :data="holidays",
            default-sort-direction="asc",
            default-sort="date",
            hoverable
          )
            b-table-column(field="date", label="Date", width="180", sortable v-slot="props")
              | {{ formatDate(props.row.date) }}
            b-table-column(field="state", label="Bundesland", sortable, v-slot="props")
              | {{ props.row.state }}
            b-table-column(field="name", label="Name", sortable, v-slot="props")
              | {{ props.row.name }}
            b-table-column(field="description", label="Beschreibung", v-slot="props")
              | {{ props.row.description }}
            b-table-column(label="Aktionen", v-slot="props")
              .button-wrapper
                b-button(type="is-danger", @click="deleteHoliday(props.row)") Löschen
    .button-wrapper.margin-top.right.bottom-float
      b-button(
        type="is-secondary",
        @click="saveHolidays(false)"
      ) Speichern
      b-button(
        type="is-primary",
        @click="saveHolidays(true)"
      ) Speichern und Schließen
</template>

<script>
import { DateTime } from "luxon";

export default {
  data() {
    return {
      year: null,
      holidays: [],
      singleVacationDay: {
        name: null,
        date: new Date(),
        description: null
      }
    };
  },
  computed: {
    // sortedHolidays() {
    //   return this.holidays.sort(function (a, b) {
    //     // Turn your strings into dates, and then subtract them
    //     // to get a value that is either negative, positive, or zero.
    //     return new Date(b.date) - new Date(a.date);
    //   });
    // },
  },
  methods: {
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    async downloadHolidays() {
      const data = await this.$store.dispatch("holidays/downloadByYear", {
        year: this.year,
      });
      
      const states = Object.keys(data);

      for (let i = 0; i < states.length; i += 1) {
        const stateHolidays = Object.keys(data[states[i]]);
        for (let x = 0; x < stateHolidays.length; x += 1) {
          this.holidays.push({
            date: data[states[i]][stateHolidays[x]].datum,
            state: states[i],
            name: stateHolidays[x],
            description: data[states[i]][stateHolidays[x]].hinweis,
          });
        }
      }
    },
    addSingleHoliday() {
      this.holidays.push({
        date: this.singleVacationDay.date.toISOString().substring(0, 10),
        state: 'MV',
        name: this.singleVacationDay.name,
        description: this.singleVacationDay.description,
      });
    },
    saveHolidays(close) {
      this.$store.dispatch("holidays/createAll", {
        holidays: this.holidays
      });

      if (close) {
        this.$router.go(-1);
      }
    },
    deleteHoliday(props) {
      if (!props.id) {
        for (let x=0; x<this.holidays.length; x+=1) {
          if (this.holidays[x].name === props.name && this.holidays[x].state === props.state) {
            this.holidays.splice(x, 1);
          }
        }
        return;
      }

      let holiday = this.holidays.find((b) => b.id === props.id);

      this.$buefy.dialog.confirm({
        title: "Feiertag löschen",
        message: `Sind Sie sicher, dass Sie diesen Feiertag <b>${holiday.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("holidays/delete", {
              id: props.id,
            });
            this.holidays = await this.$store.dispatch("holidays/findAll");
            this.$buefy.toast.open("Feiertag gelöscht!");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Feiertag konnte nicht gelöscht werden."
            );
          }
        },
      });
    },
  },
  async mounted() {
    this.holidays = await this.$store.dispatch("holidays/findAll");
  },
};
</script>

<style lang="scss" scoped>
</style>